import React from 'react';
import InputField from '../components/InputField';
import DateField from '../components/DateField';
import TimeField from '../components/TimeField';
import RadioField from '../components/RadioField';
import SelectField from '../components/SelectField';
import Checkbox from '../components/Checkbox';
import MulitSelect from '../components/MultiSelect';
import PointsField from '../components/PointsField';
import FileField from '../components/FileField';

import { validatePhases } from './Validation';

const formHelpers = {}

formHelpers.blurphase = (currentPhase) => {
  Object.keys(currentPhase).forEach(key => {
    if (currentPhase[key].isRequired && currentPhase[key] !== '') {
      currentPhase[key].hasBlurred = true;
      currentPhase[key].touched = true;
    }
  })
  return validatePhases(currentPhase);
}

formHelpers.buildFields = (phase, context, position=null, parentName=null) => {
  return Object.keys(phase).map((field, index) => {
    let dependent = phase[field].hasOwnProperty('depends_on') ? true : false;
    let is_visible = true;
    if (dependent) {
      let { depends_on } = phase[field];
      is_visible = phase[depends_on].value;
    }
    if (is_visible) {
      if (phase[field].breed === 'input' || phase[field].breed === 'textarea') {
        return (
          <InputField
            key={index}
            position={position}
            parentName={parentName}
            handleFocus={context.handleFieldFocus}
            field={phase[field]}
            handleBlur={context.handleFieldBlur}
            handleChange={context.handleFieldChange}/>
        )
      } else if (phase[field].breed === 'file') {
        return (
          <FileField
            key={index}
            position={position}
            parentName={parentName}
            handleFocus={context.handleFieldFocus}
            field={phase[field]}
            handleBlur={context.handleFieldBlur}
            handleChange={context.handleFileUpload}/>
        )
      } else if (phase[field].breed === 'points') {
        return (
          <PointsField
            key={index}
            position={position}
            parentName={parentName}
            handleFocus={context.handleFieldFocus}
            field={phase[field]}
            handleBlur={context.handleFieldBlur}
            handleChange={context.handleFieldChange}/>
        )
      } else if (phase[field].breed === 'select') {
        return (
          <SelectField
            key={index}
            position={position}
            parentName={parentName}
            field={phase[field]}
            handleBlur={context.handleFieldBlur}
            handleFocus={context.handleFieldFocus}
            handleClick={context.handleSelectClick}
            handleChange={context.handleSelectFieldChange}/>
        )
      } else if (phase[field].breed === 'checkbox') {
      return (
        <Checkbox
          key={index}
          field={phase[field]}
          handleClick={context.handleCheckboxClick}/>
      )
    } else if (phase[field].breed === 'date') {
      return (
        <DateField
          key={index}
          handleFocus={context.handleFieldFocus}
          handleBlur={context.handleFieldBlur}
          handleChange={context.handleFieldChange}
          field={phase[field]}
          handleClick={context.handleClick}/>
      )
    } else if (phase[field].breed === 'time') {
      return (
        <TimeField
          key={index}
          field={phase[field]}
          handleChange={context.handleFieldChange}/>
      )
    } else if (phase[field].breed === 'multiselect') {
      return (
        <MulitSelect
          key={index}
          field={phase[field]}
          handleClick={context.handleMultiSelectClick}/>
      )
    } else if (phase[field].breed === 'array') {
      return phase[field].values.map((nestedPhase, i) => {
        return formHelpers.buildFields(nestedPhase, context, i, phase[field].name);
      })
    } else {
      return (
        <RadioField
          key={index}
          field={phase[field]}
          handleChange={context.handleFieldChange}/>
      )
    }
  }
  })
}


formHelpers.handleMultiSelectClick = (name, index, val, phase, context, single=false) => {
  let newValues = context.state[phase][name].value;
  if (single) {
    newValues.map((val) => {
      val.value = false;
      return val;
    });
  }
	newValues[index].value = val;
  context.setState({
    [phase]: {
      ...context.state[phase],
      [name]: {
        ...context.state[phase][name],
        value: newValues
      }
    }
  })
}

formHelpers.handleFileUpload = (values, name, phase, context) => {

  new Promise((resolve, reject) => {
    context.setState({
      [phase]: {
        ...context.state[phase],
        [name]: {
          ...context.state[phase][name],
          value: values[0],
          fileName: values[0].name,
          touched: true
        }
      }
    })
    resolve();
  }).then(() => {
    context.setState({
      [phase]: validatePhases(context.state[phase])
    })
  })
}

formHelpers.handleCheckboxClick = (value, name, phase, context) => {
  context.setState({
    [phase]: {
      ...context.state[phase],
      [name]: {
        ...context.state[phase][name],
        value: value
      }
    }
  })
}

formHelpers.handleSelectArrayFieldChange = (option, name, phase, field, position, context) => {
  let newPhase = validatePhases(context.state[phase][field].values[position]);
  new Promise((resolve, reject) => {
    context.setState({
      [phase]: {
        ...context.state[phase],
        [field]: {
          ...context.state[phase][field],
          values: [
            ...context.state[phase][field].values.slice(0, position),
            {
              ...context.state[phase][field].values[position],
              [name]: {
                ...context.state[phase][field].values[position][name],
                value: option.value,
                displayValue: option.name,
                touched: true,
                isActive: false
              }
            },
            ...context.state[phase][field].values.slice(position + 1)
          ]
        }
      }
    })
    resolve();
  }).then(() => {
    context.setState({
      [phase]: {
        ...context.state[phase],
        [field]: {
          ...context.state[phase][field],
          values: [
            ...context.state[phase][field].values.slice(0, position),
            validatePhases(context.state[phase][field].values[position]),
            ...context.state[phase][field].values.slice(position + 1)
          ]
        }
      }
    })
  })
}

formHelpers.handleArrayFieldChange = (value, name, phase, field, position, context) => {
  let newPhase = validatePhases(context.state[phase][field].values[position]);
  new Promise((resolve, reject) => {
    context.setState({
      [phase]: {
        ...context.state[phase],
        [field]: {
          ...context.state[phase][field],
          values: [
            ...context.state[phase][field].values.slice(0, position),
            {
              ...context.state[phase][field].values[position],
              [name]: {
                ...context.state[phase][field].values[position][name],
                value: value,
                touched: true,
                isActive: false
              }
            },
            ...context.state[phase][field].values.slice(position + 1)
          ]
        }
      }
    })
    resolve();
  }).then(() => {
    context.setState({
      [phase]: {
        ...context.state[phase],
        [field]: {
          ...context.state[phase][field],
          values: [
            ...context.state[phase][field].values.slice(0, position),
            validatePhases(context.state[phase][field].values[position]),
            ...context.state[phase][field].values.slice(position + 1)
          ]
        }
      }
    })
  })
}

formHelpers.handleSelectFieldChange = (option, name, phase, context) => {
  new Promise((resolve, reject) => {
    context.setState({
      [phase]: {
        ...context.state[phase],
        [name]: {
          ...context.state[phase][name],
          value: option.value,
          displayValue: option.name,
          touched: true,
          isActive: false
        }
      }
    })
    resolve();
  }).then(() => {
    context.setState({
      [phase]: validatePhases(context.state[phase])
    })
  })
}

formHelpers.handleFieldChange = (value, name, phase, context) => {
  new Promise((resolve, reject) => {
    context.setState({
      [phase]: {
        ...context.state[phase],
        [name]: {
          ...context.state[phase][name],
          value: value,
          touched: true,
          isActive: false
        }
      }
    })
    resolve();
  }).then(() => {
    context.setState({
      [phase]: validatePhases(context.state[phase])
    })
  })
}

formHelpers.handleFieldBlur = (name, phase, context) => {
  let newPhase = validatePhases(context.state[phase]);
  newPhase[name].hasBlurred = true
  context.setState({
    [phase]: newPhase
  })
}

formHelpers.handleArrayFieldBlur = (name, phase, field, position, context) => {
  let newPhase = validatePhases(context.state[phase][field].values[position]);
  newPhase[name].hasBlurred = true
  context.setState({
    [phase]: {
      ...context.state[phase],
      [field]: {
        ...context.state[phase][field],
        values: [
          ...context.state[phase][field].values.slice(0, position),
          newPhase,
          ...context.state[phase][field].values.slice(position + 1)
        ]
      }
    }
  })
}

formHelpers.handleArraySelectClick = (field, currentPhase, parentName, position, context) => {
  context.setState({
    [currentPhase]: {
      ...context.state[currentPhase],
      [parentName]: {
        ...context.state[currentPhase][parentName],
        values: [
          ...context.state[currentPhase][parentName].values.slice(0, position),
          {
            ...context.state[currentPhase][parentName].values[position],
            [field.name]: {
              ...context.state[currentPhase][parentName].values[position][field.name],
              isActive: !field.isActive
            }
          },
          ...context.state[currentPhase][parentName].values.slice(position + 1)
        ]
      }
    }
  })
}

formHelpers.handleSelectClick = (field, currentPhase, context) => {
  context.setState({
    [currentPhase]: {
      ...context.state[currentPhase],
      [field.name]: {
        ...context.state[currentPhase][field.name],
        isActive: !field.isActive
      }
    }
  })
}

formHelpers.handleArrayFieldFocus = (name, phase, field, position, context) => {
  let newPhase = validatePhases(context.state[phase][field].values[position]);
  newPhase[name].touched = true
  context.setState({
    [phase]: {
      ...context.state[phase],
      [field]: {
        ...context.state[phase][field],
        values: [
          ...context.state[phase][field].values.slice(0, position),
          newPhase,
          ...context.state[phase][field].values.slice(position + 1)
        ]
      }
    }
  })
}

formHelpers.handleFieldFocus = (name, phase, context) => {
  let newPhase = validatePhases(context.state[phase]);
  newPhase[name].touched = true
  context.setState({
    [phase]: newPhase
  })
}

export default formHelpers;



/** WEBPACK FOOTER **
 ** ./src/helpers/FormHelpers.js
 **/